/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Sandboxchangelog2Inputs */

const id_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`changelog sandbox`)
};

const ms_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`changelog sandbox`)
};

const da_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandbox ændringslog`)
};

const de_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox-Änderungsprotokoll`)
};

const en_us2_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandbox changelog`)
};

const es_es2_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registro de cambios del sandbox`)
};

const es_mx2_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registro de cambios del sandbox`)
};

const fil_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`talaan ng pagbabago ng sandbox`)
};

const fr_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`journal des modifications du sandbox`)
};

const it_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registro modifiche sandbox`)
};

const hu_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandbox változásnapló`)
};

const nl_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandbox-wijzigingslogboek`)
};

const no_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandbox endringslogg`)
};

const pl_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dziennik zmian sandboxa`)
};

const pt_br2_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registro de alterações da sandbox`)
};

const pt_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registo de alterações da sandbox`)
};

const ro_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jurnal modificări sandbox`)
};

const fi_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hiekkalaatikon muutosloki`)
};

const sv_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandlådans ändringslogg`)
};

const vi_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nhật ký thay đổi sandbox`)
};

const tr_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandbox değişiklik günlüğü`)
};

const cs_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seznam změn sandboxu`)
};

const bg_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`дневник на промените на sandbox`)
};

const ru_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`журнал изменений Песочница`)
};

const uk_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`журнал змін sandbox`)
};

const ar_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل تغييرات Sandbox`)
};

const hi_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स बदलाव लॉग`)
};

const th_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลงแซนด์บ็อกซ์`)
};

const ja_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックス更新履歴`)
};

const zh_cn2_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒更新日志`)
};

const zh_hant1_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒更新日誌`)
};

const ko_offerdetail_changelog_sandboxchangelog2 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelog2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox 변경 내역`)
};

/**
* | output |
* | --- |
* | "sandbox changelog" |
*
* @param {Offerdetail_Changelog_Sandboxchangelog2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_sandboxchangelog2 = /** @type {((inputs?: Offerdetail_Changelog_Sandboxchangelog2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Sandboxchangelog2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "da") return da_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "de") return de_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "it") return it_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "no") return no_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "th") return th_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_sandboxchangelog2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_sandboxchangelog2(inputs)
	return ko_offerdetail_changelog_sandboxchangelog2(inputs)
});
export { offerdetail_changelog_sandboxchangelog2 as "offerDetail.changelog.sandboxChangelog" }